// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const shareButton_defaultMessage = (i) => `Herzliche Einladung zu meinem Event! 🤗
Alle Details sind im Link, bitte Zusage/Absage etc. dort eintragen damit ich besser planen kann.
`